<nb-tag-list (tagRemove)="onTagRemove($event)">
  @for (recipientEmail of recipients; track recipientEmail) {
    <nb-tag
      [text]="recipientEmail"
      removable>
    </nb-tag>
  }

  <input
    type="text"
    nbTagInput
    nbInput
    fullWidth
    [name]="inputName()"
    [attr.autocomplete]="autocomplete()"
    [formControl]="inputCtrl"
    [disabled]="disabled()"
    [nbAutocomplete]="auto"
    (tagAdd)="onTagAdd($event)"/>
</nb-tag-list>

<nb-autocomplete #auto (selectedChange)="onSuggestionSelected($event)">
  @for (suggestion of (suggestions$ | async); track suggestion.email) {
    <nb-option [value]="suggestion.email">
      {{suggestion.display}}
    </nb-option>
  }
</nb-autocomplete>
